import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-error403',
  templateUrl: './error403.component.html',
  styleUrls: ['./error403.component.css']
})
export class Error403Component implements OnInit {

  constructor(private renderer : Renderer2) { }

  ngOnInit(): void {
    // arreglar vista
    this.renderer.removeClass(document.body, 'vertical-overlay-menu');
    this.renderer.removeClass(document.body, 'bg-full-screen-image');
    this.renderer.removeClass(document.body, 'vertical-menu-modern');
    this.renderer.removeClass(document.body, 'fixed-navbar');    
    // arreglar vista
  }
}
